import { createAsyncThunk } from "@reduxjs/toolkit";
import { auth } from "../../firebase/config";
import { sendPasswordResetEmail } from "firebase/auth";

interface IForgetPasswordData {
  email: string;
}
interface IForgetPasswordResponse {
  message: string;
}
interface IRejectValue {
  message: string;
}

export const forgetPassword = createAsyncThunk<
  IForgetPasswordResponse,
  IForgetPasswordData,
  { rejectValue: IRejectValue }
>("auth/forgetPassword", async ({ email }, thunkAPI) => {
  try {
    await sendPasswordResetEmail(auth, email);

    return {
      message: "Password reset link sent successfully."
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      message: error.message ?? "Something went wrong."
    });
  }
});
